import style from './form-incut.module.scss';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import FormIncutStatus from './form-incut-status/form-incut-status';
import { sendSubscribe } from '@services/subscriptions.service';

interface FormIncutProps {
  title: string;
  text: string;
  buttonText: string;
  articleId: string;
}

enum FORM_STATUS {
  active = 'active',
  success = 'success',
  error = 'error',
}

const COVER_REMOVE_TIMEOUT = 3000; // milliseconds

const FormIncut = ({ title, text, buttonText, articleId }: FormIncutProps) => {
  const [currentFormStatus, setFormStatus] = useState(FORM_STATUS.active);

  useEffect(() => {
    const isFormSubmitted = [FORM_STATUS.success, FORM_STATUS.error].includes(currentFormStatus);
    if (isFormSubmitted) {
      setTimeout(() => {
        setFormStatus(FORM_STATUS.active);
      }, COVER_REMOVE_TIMEOUT);
    }
  }, [currentFormStatus]);

  const onSubmit = (success: boolean) => {
    if (success) {
      setFormStatus(FORM_STATUS.success);
    } else {
      setFormStatus(FORM_STATUS.error);
    }
  };
  return (
    <>
      <div
        className={`${style.incut} ${currentFormStatus !== FORM_STATUS.active ? null : style.incut_active}`}
      >
        <div className={`${style.incut__title}`}>{title}</div>
        <div className={`${style.incut__text}`}>{text}</div>
        <Formik
          initialValues={{ email: '' }}
          isInitialValid={false}
          validationSchema={Yup.object({
            email: Yup.string()
              .required('Please enter your email address')
              .email('Please enter a valid email address'),
          })}
          onSubmit={async (values, actions) => {
            actions.setSubmitting(true);
            sendSubscribe(values.email, articleId)
              .then(() => {
                onSubmit(true);
                actions.setSubmitting(false);
                actions.resetForm();
              })
              .catch((err) => {
                onSubmit(false);
                actions.setSubmitting(false);
              });
            actions.resetForm();
          }}
        >
          {(formik) => (
            <Form className={style.incut__form}>
              <div className={style.incut__item}>
                <input
                  {...formik.getFieldProps('email')}
                  placeholder="Enter your email address"
                  name="email"
                  className={`${style.incut__item__input} ${formik.touched.email && formik.errors.email ? style.incut__item__input_invalid : style.incut__item__input}`}
                  type="email"
                />
                <button className={style.incut__item__button}>
                  <div className={`${style.incut__item__button__text}`}>{buttonText}</div>
                </button>
              </div>
              {formik.touched.email && formik.errors.email ? (
                <div className={style.incut__invalidEmail}>{formik.errors.email}</div>
              ) : null}
            </Form>
          )}
        </Formik>
      </div>
      {currentFormStatus !== FORM_STATUS.active && (
        <div className={style.incut__status}>
          <FormIncutStatus
            status={currentFormStatus === FORM_STATUS.success ? 'success' : 'failure'}
          />
        </div>
      )}
    </>
  );
};

export default FormIncut;
